import { Button, Col, Descriptions, Form, Input, Modal, Row } from 'antd';
import {
  appointmentConst,
  buttonLabel,
  messages,
} from '../../../constants';

export const RedemptionBranchAuthorizationModal = ({
  open,
  detail,
  loading = false,
  onCancel,
  onConfirm,
}) => {
  const [form] = Form.useForm();

  const cancel = () => {
    form.resetFields();
    onCancel();
  };

  const confirm = async (values) => {
    const completed = await onConfirm(values);
    if (completed) form.resetFields();
  };

  return (
    <Modal
      open={open}
      title={appointmentConst.REDEMPTION_BRANCH.TITLE}
      onCancel={cancel}
      footer={null}
      destroyOnClose
    >
      <Descriptions column={1} size="small">
        <Descriptions.Item label="Orden">
          {detail?.order?.orderNumber || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Tratamiento seleccionado">
          {detail?.treatment?.name}
        </Descriptions.Item>
        <Descriptions.Item label="Sucursal responsable actual">
          {detail?.responsibleBranch?.name}
        </Descriptions.Item>
        <Descriptions.Item label="Sucursal destino">
          {detail?.destinationBranch?.name}
        </Descriptions.Item>
      </Descriptions>

      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={confirm}
      >
        <Form.Item
          name="authorizationCode"
          label={appointmentConst.REDEMPTION_BRANCH.CODE_LABEL}
          rules={[
            {
              required: true,
              message: messages.required(
                appointmentConst.REDEMPTION_BRANCH.CODE_LABEL
              ),
            },
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          name="transferReason"
          label={appointmentConst.REDEMPTION_BRANCH.REASON_LABEL}
          rules={[
            {
              required: true,
              whitespace: true,
              message: messages.required(
                appointmentConst.REDEMPTION_BRANCH.REASON_LABEL
              ),
            },
          ]}
        >
          <Input.TextArea maxLength={1000} showCount rows={4} />
        </Form.Item>

        <Row justify="end" gutter={8}>
          <Col>
            <Button htmlType="button" onClick={cancel} disabled={loading}>
              {buttonLabel.cancel}
            </Button>
          </Col>
          <Col>
            <Button type="primary" htmlType="submit" loading={loading}>
              {buttonLabel.confirmBranchChange}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
